import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import { map, Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-Add-ItemType',
  templateUrl: './Add-ItemType.component.html',
  styleUrls: ['./Add-ItemType.component.scss']
})
export class AddItemTypeComponent implements OnInit {

  private readonly databaseURL = 'https://i-monitor-19ba2-default-rtdb.firebaseio.com/';
  private readonly secret = '8G9l51WypQ5TlYCmB8qsoLzj89fn0ZM4YKGLUxFy';
  private readonly collectionPath = 'itemTypes';

 AddItemTypeForm: FormGroup;
  displayedColumns: string[] = [
    "ID",
    "Name",
    "TempValue",
    "HumValue",
    "TempOperator",
    "HumOperator",
    "action"
  ];
  ItemTypes: any;
  update: boolean;
  ItemTypeId: any;
  Operator:any=[
    {
      id:1,
      name:'='
    },
    {
      id:2,
      name:'>'
    },
    {
      id:3,
      name:'<'
    },
    {
      id:4,
      name:'<='
    },
    {
      id:5,
      name:'>='
    },
    {
      id:6,
      name:'!='
    },
  ]
  
  constructor(private _formBuilder: FormBuilder,  public GeneralService: GeneralService,private http: HttpClient) {
    
   }
initForm() {
    this.AddItemTypeForm = this._formBuilder.group({
    Name: [ '', Validators.required],
    TempValue:[''],
    HintMessageTemp: [''],
    TempOperator:[''],
    firstmarkertemp:[''],
    secondmarkertemp:[''],
    thirdmarkertemp:[''],
    fourthmarkertemp:[''],

    firstholdtemp:[''],
    secondholdtemp:[''],
    thirdholdtemp:[''],
  
    HumValue:[''],
    HumOperator:[''],
    HintMessageHum: [''],
    firstmarkerhum:[''],
    secondmarkerhum:[''],
    thirdmarkerhum:[''],
    fourthmarkerhum:[''],

    firstholdhum:[''],
    secondholdhum:[''],
    thirdholdhum:['']
  
    });
  }


  createCollection(collection: any): Observable<any> {
    return this.http.post<any>(
      `${this.databaseURL}/${this.collectionPath}.json?auth=${this.secret}`,
      collection
    );
  }

  // Get all collections
  getCollections(): Observable<any[]> {
    return this.http.get<{[key: string]: any}>(
      `${this.databaseURL}/${this.collectionPath}.json?auth=${this.secret}`
    ).pipe(
      map(response => {
        if (!response) return [];
        return Object.keys(response).map(key => ({
          id: key,
          ...response[key]
        }));
      })
    );
  }

  // Get a single collection by ID


  // Update a collection
  updateCollection(id: string, collection: any): Observable<any> {
    return this.http.put<any>(
      `${this.databaseURL}/${this.collectionPath}/${id}.json?auth=${this.secret}`,
      collection
    );
  }

  // Delete a collection
  deleteCollection(id: string): Observable<null> {
    return this.http.delete<null>(
      `${this.databaseURL}/${this.collectionPath}/${id}.json?auth=${this.secret}`
    );
  }


  ngOnInit() {
    this.loadCollections();
    this.initForm();
  }
  get fc() {
    return this.AddItemTypeForm.controls;
  }



InsertItemType(){
  const data={
    name:this.AddItemTypeForm.get("Name").value,
    tempValue:this.AddItemTypeForm.get("TempValue").value,
    hintMessageTemp: this.AddItemTypeForm.get("HintMessageTemp").value,
    tempOperator:this.AddItemTypeForm.get("TempOperator").value,
    humValue:this.AddItemTypeForm.get("HumValue").value,
    humOperator:this.AddItemTypeForm.get("HumOperator").value,
    hintMessageHum: this.AddItemTypeForm.get("HintMessageHum").value,
    firstmarkertemp:this.AddItemTypeForm.get("firstmarkertemp").value,
    secondmarkertemp:this.AddItemTypeForm.get("secondmarkertemp").value,
    thirdmarkertemp:this.AddItemTypeForm.get("thirdmarkertemp").value,
    fourthmarkertemp:this.AddItemTypeForm.get("fourthmarkertemp").value,
    firstholdtemp:this.AddItemTypeForm.get("firstholdtemp").value,
    secondholdtemp:this.AddItemTypeForm.get("secondholdtemp").value,
    thirdholdtemp:this.AddItemTypeForm.get("thirdholdtemp").value,
    firstmarkerhum:this.AddItemTypeForm.get("firstmarkerhum").value,
    secondmarkerhum:this.AddItemTypeForm.get("secondmarkerhum").value,
    thirdmarkerhum:this.AddItemTypeForm.get("thirdmarkerhum").value,
    fourthmarkerhum:this.AddItemTypeForm.get("fourthmarkerhum").value,
    firstholdhum:this.AddItemTypeForm.get("firstholdhum").value,
    secondholdhum:this.AddItemTypeForm.get("secondholdhum").value,
    thirdholdhum:this.AddItemTypeForm.get("thirdholdhum").value,

  }

  // this.GeneralService.addItemType(data).then(res=>{
  //   this.GetAllItemTypes();
  //   this.AddItemTypeForm.reset();
  // })
  this.createCollection(data).subscribe(() => {
    this.loadCollections();
    this.AddItemTypeForm.reset();

   
  });}

  loadCollections() {
    this.getCollections().subscribe(
      collections =>this.ItemTypes= collections
    );
  }

UpdateItemType(){
  const data={
    name:this.AddItemTypeForm.get("Name").value,
    tempValue:this.AddItemTypeForm.get("TempValue").value,
    hintMessageTemp: this.AddItemTypeForm.get("HintMessageTemp").value,
    tempOperator:this.AddItemTypeForm.get("TempOperator").value,
    humValue:this.AddItemTypeForm.get("HumValue").value,
    humOperator:this.AddItemTypeForm.get("HumOperator").value,
    hintMessageHum: this.AddItemTypeForm.get("HintMessageHum").value,
    firstmarkertemp:this.AddItemTypeForm.get("firstmarkertemp").value,
    secondmarkertemp:this.AddItemTypeForm.get("secondmarkertemp").value,
    thirdmarkertemp:this.AddItemTypeForm.get("thirdmarkertemp").value,
    fourthmarkertemp:this.AddItemTypeForm.get("fourthmarkertemp").value,
    firstholdtemp:this.AddItemTypeForm.get("firstholdtemp").value,
    secondholdtemp:this.AddItemTypeForm.get("secondholdtemp").value,
    thirdholdtemp:this.AddItemTypeForm.get("thirdholdtemp").value,
    firstmarkerhum:this.AddItemTypeForm.get("firstmarkerhum").value,
    secondmarkerhum:this.AddItemTypeForm.get("secondmarkerhum").value,
    thirdmarkerhum:this.AddItemTypeForm.get("thirdmarkerhum").value,
    fourthmarkerhum:this.AddItemTypeForm.get("fourthmarkerhum").value,
    firstholdhum:this.AddItemTypeForm.get("firstholdhum").value,
    secondholdhum:this.AddItemTypeForm.get("secondholdhum").value,
    thirdholdhum:this.AddItemTypeForm.get("thirdholdhum").value

  }
  // this.GeneralService.UpdateItemType(data,this.ItemTypeId).then(res=>{
  //   this.GetAllItemTypes();
  //   this.AddItemTypeForm.reset();
  //   this.update=false;
  // })

  this.updateCollection(this.ItemTypeId, data).subscribe(() => {
    this.loadCollections();
    this.AddItemTypeForm.reset();
    this.update=false;

  });

}
Edit(item){
  this.ItemTypeId=item.id;
  this.update=true;
this.AddItemTypeForm.get("Name").setValue(item.name);
this.AddItemTypeForm.get("TempValue").setValue(item.tempValue);
this.AddItemTypeForm.get("HintMessageTemp").setValue(item.hintMessageTemp);
this.AddItemTypeForm.get("TempOperator").setValue(item.tempOperator);
this.AddItemTypeForm.get("HumValue").setValue(item.humValue);
this.AddItemTypeForm.get("HumOperator").setValue(item.humOperator);
this.AddItemTypeForm.get("HintMessageHum").setValue(item.hintMessageHum);
this.AddItemTypeForm.get("firstmarkertemp").setValue(item.firstmarkertemp);
this.AddItemTypeForm.get("secondmarkertemp").setValue(item.secondmarkertemp);
this.AddItemTypeForm.get("thirdmarkertemp").setValue(item.thirdmarkertemp);
this.AddItemTypeForm.get("fourthmarkertemp").setValue(item.fourthmarkertemp);
this.AddItemTypeForm.get("firstholdtemp").setValue(item.firstholdtemp);
this.AddItemTypeForm.get("secondholdtemp").setValue(item.secondholdtemp);
this.AddItemTypeForm.get("thirdholdtemp").setValue(item.thirdholdtemp);
this.AddItemTypeForm.get("firstmarkerhum").setValue(item.firstmarkerhum);
this.AddItemTypeForm.get("secondmarkerhum").setValue(item.secondmarkerhum);
this.AddItemTypeForm.get("thirdmarkerhum").setValue(item.thirdmarkerhum);
this.AddItemTypeForm.get("fourthmarkerhum").setValue(item.fourthmarkerhum);
this.AddItemTypeForm.get("firstholdhum").setValue(item.firstholdhum);
this.AddItemTypeForm.get("secondholdhum").setValue(item.secondholdhum);
this.AddItemTypeForm.get("thirdholdhum").setValue(item.thirdholdhum);





}





Submit(){
  console.log(this.AddItemTypeForm.value)
  if (this.AddItemTypeForm.status == "VALID") {
    if (this.update == true) {
      this.UpdateItemType();
    } 
    else {
      this.InsertItemType()
    }
  }
   else {
    this.AddItemTypeForm.markAllAsTouched();
  }
}
}
